export default "__VITE_ASSET__ztCSQEpi__"